module.exports = __webpack_public_path__ + "static/media/strip-tablet-bear-desk.a058491e.png";